const brandCard = ({ image, tagline, title, description, link, icon }) => `<div class="brand-card">
    <div class="brand-card__body">
        <div class="brand-card__tagline">
            ${icon.url !== null ? `
                <span><img class="brand-card__icon" alt="${icon.alt}" src="${icon.url}" /></span>
            ` : ``}
        </div>
        <h3 class="h5 brand-card__title">${title}</h3>
        <p class="brand-card__desc">${description}</p>
    </div>
    <div class="brand-card__footer">
        <a href="${link.url}" class="brand-card__btn btn -underline">${link.text}</a>
    </div>
</div>`

export { brandCard };
